import React from 'react'
import Bugsnag from '@bugsnag/js'
import { Event } from '@bugsnag/core'

import { UnhandledError } from './components/UnhandledError'

const BugsnagErrorBoundary =
  Bugsnag.getPlugin('react')?.createErrorBoundary(React)

type ErrorBoundaryProps = {
  noCrashScreen?: boolean
  children: React.ReactNode
  onError?: (error: Event) => void
}

export function ErrorBoundary({
  noCrashScreen,
  children,
  onError,
}: ErrorBoundaryProps) {
  const superEnabled = window.location.pathname.startsWith(
    '/organization/super' //cant use react router here
  )
  if (!BugsnagErrorBoundary) {
    return <>{children}</>
  }

  return (
    <BugsnagErrorBoundary
      onError={(event: Event) => {
        if (!noCrashScreen) {
          event.errors[0].errorClass = 'AppCrash'
        }
        if (onError) {
          onError(event)
        }
      }}
      FallbackComponent={
        noCrashScreen
          ? undefined
          : ({ error }) => (
              <UnhandledError error={error} superEnabled={superEnabled} />
            )
      }
    >
      {children}
    </BugsnagErrorBoundary>
  )
}
